import { Link } from "react-router-dom";

export interface TopicCardData {
  id: string;
  title: string;
  category: string;
  summary: string;
  cover: string;
  date: string;
  readTime: string;
  views: string;
  tags: string[];
}

interface TopicCardProps {
  topic: TopicCardData;
  variant?: "default" | "plain";
}

export default function TopicCard({ topic, variant = "default" }: TopicCardProps) {
  const isPlain = variant === "plain";
  return (
    <article
      className={`group flex h-full flex-col overflow-hidden rounded-lg border transition-colors duration-300 ${
        isPlain
          ? "border-transparent bg-transparent"
          : "border-background-200 bg-background-50 hover:border-primary-300"
      }`}
    >
      <Link
        to={`/topics/${topic.id}`}
        className="block h-44 w-full overflow-hidden bg-background-200 md:h-48"
        aria-label={topic.title}
      >
        <img
          src={topic.cover}
          alt={`${topic.title}专题配图`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </Link>
      <div className={`flex flex-1 flex-col ${isPlain ? "pt-4" : "p-4 md:p-5"}`}>
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
            {topic.category}
          </span>
          <span className="text-xs text-foreground-500">{topic.date}</span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/topics/${topic.id}`} className="transition-colors hover:text-primary-600">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {topic.summary}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-sm" />
            {topic.readTime}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-eye-line text-sm" />
            {topic.views}
          </span>
        </div>
      </div>
    </article>
  );
}